import React, { useEffect, useState } from "react";
import CalculateComp from "../components/CalculateComp";
import ResultComp from "../components/ResultComp";
import ExploreLinks from "../components/ExploreLinkComp";
import AboutComp from "../components/AboutComp";
import { Link, useLocation, useParams } from "react-router-dom";
import Card2Mock from "../components/Card2mock";
import { CircularProgress } from "@mui/material";
import PageSEO from "../components/SEO_Component/PageSEO";
import BreadcrumbNav from "../components/BreadcrumbNav";
import FlashOnIcon from "@mui/icons-material/FlashOn";

function SipCalculator() {
  const [calcData, setData] = useState({});
  const [inputArr, setInputArr] = useState([]);
  const [calculatorsList, setCalcList] = useState([]);
  const [blogList, setBlogList] = useState([]);
  const [seo, setSEO] = useState({});
  const { lang, id } = useParams();
  const [responseData, setResponseData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  //Responsive
  const [matches, setMatches] = useState(
    window.matchMedia("(min-width: 768px)").matches
  );

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant",
    });

    window
      .matchMedia("(min-width: 768px)")
      .addEventListener("change", (e) => setMatches(e.matches));

    fetch(`${process.env.REACT_APP_API}${lang}/calculator/${id}?debug=true`)
      .then((response) => response.json())
      .then((data) => {
        setData(data["data"]);
        setSEO(data["seo"]);
        setInputArr(data["data"]["input"]["input"]);
        setCalcList(data["similar1"]);
        console.log(calculatorsList);
      })
      .catch((err) => {
        console.log(err.message);
      });
    fetch(`${process.env.REACT_APP_API}${lang}/calculator/*?debug=true`)
      .then((response) => response.json())
      .then((data) => {
        console.log(data.seo);
        setBlogList(data["similar_blog"]);
      });
    setIsLoading(false);
  }, [lang, id]);

  const handleResponseData = (data) => {
    setResponseData(data);
  };

  const nav = [
    {
      caption: "Home",
      href: `/${lang}`,
    },
    {
      caption: "Calculators",
      href: `/${lang}/tools`,
    },
    {
      caption: calcData["title"],
      href: location.pathname,
    },
  ];

  return (
    <>
      {isLoading && (
        <div className="w-full flex items-center justify-center h-[80vh]">
          <CircularProgress />
        </div>
      )}

      {!isLoading && (
        <>
          <BreadcrumbNav pathSegments={nav} />
          <div className="flex-col h-full w-full md:px-10">
            <PageSEO seoData={seo} />

            <h1 className="mt-4 text-[#00000094] text-2xl flex justify-center text-center font-montserrat font-semibold">
              {calcData["title"]}
            </h1>
            <div className="flex justify-center">
              <img className="w-1/4" src={calcData["image"]} />
            </div>
            <div className="mt-1 text-[#000000] text-sm flex justify-center text-center font-montserrat font-semibold mx-2">
              {calcData["subtitle"]}
            </div>
            <div className="flex justify-center">
              <hr className="w-full bg-black m-2" />
            </div>
            <div className="flex">
              <FlashOnIcon style={{ fill: "#00C6CA" }} />
              <div className="text-black font-sm">
                Try <a href="/english/fintragpt">Fintra</a> now.
              </div>
            </div>
            <div className="md:grid md:grid-cols-2 md:mt-10">
              <div>
                <CalculateComp
                  arr={inputArr}
                  id={id}
                  language={calcData.language}
                  onResponse={handleResponseData}
                />
                <ResultComp responseData={responseData} />
              </div>

              <AboutComp content={calcData["output1"]} />
            </div>
            <hr className="bg-grey m-2" />
            {!matches && calculatorsList && calculatorsList.length > 0 && (
              <ExploreLinks
                heading="Explore Other Popular Calculators"
                arr={calculatorsList}
                isCalcList={true}
                lang={lang}
              />
            )}
            {matches && calculatorsList && calculatorsList.length > 0 && (
              <div className="md:grid md:grid-cols-3 gap-4">
                {calculatorsList.map((calc) => (
                  <Link to={`/${lang}/calculator/${calc.id}`}>
                    <div className="justify-center hover:cursor-pointer">
                      <Card2Mock img={calc.image} title={calc["title"]} />
                    </div>
                  </Link>
                ))}
              </div>
            )}
            <hr className="bg-grey m-2" />

            {blogList && blogList.length > 0 && (
              <ExploreLinks
                heading="You may also be Interested in -"
                arr={blogList}
                isCalcList={false}
              />
            )}
            <></>
          </div>
        </>
      )}
    </>
  );
}

export default SipCalculator;
